import { FormControl, FormHelperText, FormLabel, MenuItem, Select, SelectChangeEvent, SxProps } from '@mui/material';
import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface IProps {
  options: { id: string | number; title: string }[];
  onChange: (value: string) => void;
  label?: string;
  name: string;
  value?: string | number;
  sx?: SxProps;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}

export const CustomSelect: React.FC<IProps> = ({ options, label, name, onChange, value, sx, error = false, helperText, disabled }) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth sx={sx} error={error}>
      {label && <FormLabel error={error}>{label}</FormLabel>}
      <Select
        id={`select-${name}`}
        name={name}
        variant="outlined"
        value={String(value ?? '')}
        onChange={handleChange}
        className="psf-form__item psf-form__item-select"
        displayEmpty
        error={error}
        disabled={disabled}
        IconComponent={KeyboardArrowDownIcon}
        sx={{ width: '100%' }}
      >
        <MenuItem value="">
          <em>Bitte wählen</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.id} value={String(option.id)} sx={{ fontFamily: 'SparkasseWeb', fontSize: '16px' }}>
            {option.title}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControl>
  );
};
